import { TriangleAlertIcon } from "lucide-react";
import type { UsageStatistic } from "../../types/subscription";

type Props = {
    limit: number;
    limitReached: boolean;
    value: number;
    entity: UsageStatistic;
}

const EntityLimitCard: React.FC<Props> = ({
    limit,
    limitReached,
    value,
    entity
}) => {
    return (
        <div className={`flex items-center px-4 py-2 border gap-2
                        ${limitReached ? "border-red-600 text-red-600" : "border-primary text-primary"} 
                        rounded-md`}>
            <span>
                {value} / {limit} {entity}
            </span>
            {limitReached && <TriangleAlertIcon color="red" />}
        </div>
    )
}

export default EntityLimitCard;